export const environment = {
  production: false,
  hostUrl: 'https://uat-jjmarket.vthgdigital.com',
  apiUrl: 'https://uat-jjmarket.vthgdigital.com/api',
};
